import { Stack, Container, Typography, Box } from '@mui/material';
import OtpForm from 'src/sections/authentication/forgot/OtpForm';
import AuthBrandPanel from '../components/authentication/AuthBrandPanel';
import { AuthRootStyle, AuthSectionStyle, AuthContentStyle } from '../components/authentication/authLayoutStyles';
import { RESET_EMAIL_KEY } from 'src/utils/clutchAdminAuth';

export default function OtpVerification() {
  const email = localStorage.getItem(RESET_EMAIL_KEY) || '';

  return (
    <AuthRootStyle title={`Verify code | ${process.env.REACT_APP_PROJECTNAME}`}>
      <AuthSectionStyle sx={{ display: { xs: 'none', md: 'flex' } }}>
        <AuthBrandPanel />
      </AuthSectionStyle>

      <Container maxWidth="sm">
        <AuthContentStyle>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 4 }}>
            <AuthBrandPanel compact />
          </Box>

          <Stack sx={{ mb: 3 }}>
            <Typography className="heading_center" sx={{ color: '#F3F4F6 !important' }} variant="h5" gutterBottom>
              Enter verification code
            </Typography>
            <Typography className="heading_center" sx={{ color: '#9CA3AF !important' }}>
              {email
                ? `We sent a 6-digit code to ${email}. Check your inbox and spam folder.`
                : 'Enter the 6-digit code from your email.'}
            </Typography>
          </Stack>

          <OtpForm />
        </AuthContentStyle>
      </Container>
    </AuthRootStyle>
  );
}
